var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeakDetector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 27.7742C36 33.974 31.0751 39 25 39C18.9249 39 14 33.974 14 27.7742C14 21.5744 25 10 25 10C25 10 36 21.5744 36 27.7742Z",
    stroke: "#F57F20",
    strokeWidth: 1.6,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.8,
    y: 0.8,
    width: 48.4,
    height: 48.4,
    rx: 8.2,
    stroke: "#F57F20",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeakDetector);
export default __webpack_public_path__ + "static/media/LeakDetector.cf322192bfd8a5d2d0e8b1cb8594101c.svg";
export { ForwardRef as ReactComponent };